import {Component, Input, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'lib-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              private location: Location) {
  }

  navigateBack(): void {
    const previousUrl = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl;
    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.location.back(); // Fallback to browser history
    }
  }
}
